'use strict';

const $ = window.jQuery;

export default class Plezi {
    constructor() {
        setTimeout(() => {
            $('.controls').find('select').select2({
                width: '100%',
                theme: 'primx'
            }).on('select2:open', function () {
                $('.select2-results__options').niceScroll({
                    cursorcolor: '#333',
                    cursorborder: '0',
                    cursorborderradius: '0'
                });
            });
        }, 1000);
    }
}
